n<template>

  <!-- <v-card width="100%" class="ma-0 pa-0" style="background-color: #161616;"> -->
  <v-card width="100%" class="ma-0 pa-0 bg_page">

    <v-card width="100%" height="100%" class="ma-0 pa-0 d-flex transparent">

      <!------------------ LHS -------------------------------->
      <v-card width="65%" height="90%" class="ma-0 pa-0 transparent">

        <!------------------ 1st row ------------------------>
        <v-card width="100%" class="ma-0 pa-0 d-flex transparent elevation-0 border-0">
          
          <!---------------- BasicInfo ---------------------->
          <v-card width="35%" min-height="270px" height="40vh" class="ml-1 mt-1 pa-0 transparent elevation-0 border-0" 
          style="height: calc(100vh - 330px);">
            <DevStatus2BasicInfo title="Basic Info" :width="statusW2" height="100%" :levels="aryBasic"
            :bgcolor="boxBgColor" :DevObj="devObj" class="mt-1 ml-0 bg_card"/>
          </v-card>

          <!---------------- Carousel (image) --------------->
          <!-- <v-sheet  width="63%" min-height="270px" height="40vh" class="ml-3 mt-2 pa-0 rounded-lg" :color="boxBgColor"> -->
          <v-sheet  width="65%" min-height="270px" height="40vh" class="ml-2 mt-2 pa-0 rounded-lg bg_card" 
          style="height: calc(100vh - 330px);">
            <v-carousel width="100%" height="100%" class="ma-0 pa-0 rounded-lg transparent">
              <v-sheet v-if="bImageExist"  width="100%" height="100%" class="ma-0 pa-0 transparent">
              <v-carousel-item v-for="(item,i) in aryPic" :key="i">
                <v-img :src="item.src" contain height="100%"></v-img>
              </v-carousel-item>
              </v-sheet>
              <v-sheet v-else width="80%" height="80%" class="ma-auto transparent">
                <v-img :src="picNoImage" contain width="100%" height="100%"></v-img>
              </v-sheet>
            </v-carousel>
          </v-sheet>

        </v-card>

        <!------------------ 2nd row ------------------------>
        <v-card width="100%" max-height="250" class="mx-0 mt-2 pa-0 d-flex transparent elevation-0 border-0" >
          
          <!---------------- Timeline (L) ---------------------->
          <v-card width="54%" height="100%" class="ml-1 mt-0 rounded-lg border-0 bg_card" >
            <!---- header ---->
            <v-card width="100%" height="40px" class="mx-0 pa-0 mt-1 d-flex transparent elevation-0">
              <!-- <v-sheet width="30%" class="mt-5 rounded transparent green--text">
                <v-img :width="30" :src="heartwaveIcon" class="ml-2"></v-img>
              </v-sheet>  -->
              <v-card width="45px" height="45px" class="transparent elevation-0" style="position: relative;">
                <v-sheet width="45px" height="45px" color="green" class="ml-2 mt-2 pa-0 rounded-pill elevation-0" 
                  style="filter: blur(2px); opacity: 0.4; position: absolute; top:0; left:0;" >
                </v-sheet>
                <v-img :width="30" :src="heartwaveIcon" class="ml-4 mt-4 elevation-0"></v-img>
              </v-card>  

              <v-sheet class="transparent">
                <v-row width="70%" class="mt-1 transparent elevation-0">
                  <v-sheet class="ml-8 transparent white--text elevation-0 border-0 fontTimeLine1">{{ rescueTimes }} times</v-sheet>
                </v-row>
                <v-row width="80%" class="pa-0 d-flex">
                  <v-sheet class="ml-8 mt-n2 transparent grey--text fontTimeLine2 elevation-0 border-0 ">Rescue</v-sheet>
                  <select class="mt-n1 ml-2 px-1 py-0 grey lighten-4 black--text rounded" @click="onChangeRescue" 
                  style="height: 18px; padding: 2; font-family: Montserrat; font-size: 0.7em; font-weight: 580;">
                    <option value="1">1 days</option>
                    <option value="7">7 days</option>
                    <option value="30" selected>30 days</option>
                  </select>
                </v-row>
              </v-sheet>
            </v-card>

            <!---- timeline body ---->
            <v-card id="id_timeline"  width="100%" height="115px" class="ml-1 mt-6 pa-0 transparent elevation-0" style="overflow-y: scroll;">
              <!-- <v-timeline  align-top dense dark class="pt-0 ml-n5 mt-0 transparent">
                <v-timeline-item v-for="item in aryEmergs" :key="item.id" color="orange" class="mt-2 pa-0 white--text" small fill-dot>
                  <v-sheet class="transparent white--text fontN2">{{getReceiveTime(item.datetime)}}</v-sheet>
                </v-timeline-item>
              </v-timeline>  -->

              <v-timeline v-if="rescueTimes !== '0'" align-top dense dark class="pt-0 ml-n5 mt-0 transparent">
                <v-timeline-item v-for="item in aryEmergs" :key="item.id" color="#63625f"  
                  class="mt-2 pa-0 white--text" small icon="mdi-checkbox-blank-circle" fill-dot icon-color="orange">
                  <v-sheet class="transparent white--text fontTimeLst">{{item.receiveTime}}</v-sheet>
                </v-timeline-item>
              </v-timeline>
              <v-sheet v-else width="auto" height="20px" class="transparent ">
                  <p class="mt-5 grey--text text--lighten-1 text-center text-h5" style="font-family: Montserrat; font-size: 0.9em;">No Rescue data within {{selectRescue}} days</p>
              </v-sheet>
            </v-card>
          </v-card>

          <!------------- Bottom 4 Boxes (R) --------------->
          <!-- <v-sheet width="63%" height="380px" class="ml-3 mt-2 pa-0 rounded-lg" :color="boxBgColor"> -->
          <v-card width="100%" height="100%" class="ml-2 mt-0 transparent elevation-0 border-0">
            
            <v-sheet  height="90px" class="ma-0 pa-0 transparent d-flex">
              <DevStatus2 title="Battery Status" width="100%"  height="100%" :levels="aryBatt"
                :bgcolor="boxBgColor" iconType="battery" :iconLevel="iconBattLevel" :iconColor="iconBattColor" 
                class="ma-0 pa-0"/>   
              <DevStatus2 title="Pads Status"  width="100%"  height="100%" :levels="aryPads"
                :bgcolor="boxBgColor" iconType="generic" :iconLevel="iconPadsLevel" :iconColor="iconPadsColor" 
                class="ml-1 my-0 pa-0"/> 
            </v-sheet>

            <v-sheet  height="90px" class="mx-0 mt-1 px-0 pb-2 transparent d-flex">
              <DevStatus2 title="Device Status" width="100%" height="100%" :levels="aryDev"
                :bgcolor="boxBgColor" iconType="generic" :iconLevel="iconDevStatusLevel" :iconColor="iconDevStatusColor" 
                class="ma-0 pa-0"/>  
              <DevStatus2Nwk :title="netTitle" width="100%" height="100%" :levels="aryNetwork"
                :bgcolor="boxBgColor" :iconType="iconNwkType" :iconLevel="iconNwkLevel" :iconColor="iconNwkColor"
                class="ml-1 my-0 pa-0"/>
            </v-sheet>
            
          </v-card>

        </v-card>

      </v-card>

      <!------------------ Map RHS ----------------------------->
      <v-card width="35%" min-height="400px"  :color="mapBkColor" class="ml-2 mt-2 mb-1 pa-1 rounded-xl elevation-0" 
      style="height: calc(100vh - 160px);" >
        <v-card width="99%" height="35px" :color="mapBkColor" class="mt-0 pa-0 d-flex elevation-0">
          <v-img :aspect-ratio="1" width="12px" height="20px" :src="locationIcon" class="ml-1 mt-1 elevation-0"></v-img>
          <v-sheet width="25%" height="100%" :color="mapBkColor" class="ml-2 mt-0 transparent white--text fontN">Location </v-sheet>
          <v-sheet width="70%" height="100%" :color="mapBkColor" justify="center" class="ml-2 mt-0 pa-0 
          transparent white--text fontN3" style="word-break: break-word">{{ map.location }}</v-sheet>
        </v-card>

        <v-card width="99%" height="20px" color="transparent" class="mb-1 pa-0 elevation-0">
          <dialogMap2 activator="parent" :location="outRangeLocation" :enabled="outRangeEnable" newWidth="700" newHeight="500"/>
        </v-card>

        <!-- <GoogleMap width="100%" height="100%" class="ma-0" :class="getMapClass" :location="devObj.InstLoc"/> -->
        <GoogleMap width="100%" height="95%" class="ma-0 mt-2 rounded-xl" :class="getMapClass" 
        :ppLocation="getLocation(devObj2)" />

      </v-card>

    </v-card>
    
  </v-card>
</template>



<script>
import axios from 'axios'
import moment from 'moment'
import cookies from '@/js/Cookie.js'
import sess from '@/js/SessionStorage.js'
import * as Ut from '@/js/ut.js'
// import devTable from '@/components/Common/DeviceTable.vue'
import * as Emergency from '@/js/samples/Emergency.js'
import GoogleMap from '@/components/Common/GoogleMap'
import DevStatus2 from '@/components/DevInfoPage/DevStatus2'
import DevStatus2Nwk from '@/components/DevInfoPage/DevStatus2Nwk'
import DevStatus2BasicInfo from '@/components/DevInfoPage/DevStatus2BasicInfo'
import dialogMap2 from '@/components/Common/dialogMap2'

import SvgIcon from '@jamescoyle/vue-icon';
import { mdiToothbrushElectric } from '@mdi/js';

  export default {
    name: 'TblBasic',

    components: {
      GoogleMap, SvgIcon, DevStatus2, DevStatus2Nwk, DevStatus2BasicInfo, dialogMap2
    },

    props: {
      devObj: {type: Object},
      testInfo: {type: Object},
      isTstExist: {type: Boolean, default: false},
      trigger: {type: Number, default: 0}
    },

    data () {
      return {
        axiosPathEmergencySn: '/api/v1/emergreports',
        heartwaveIcon: require("@/assets/Images/icons/heartwave1.png"),
        locationIcon: require("@/assets/Images/icons/location1.png"),
        axiosPathGetDevInfoV1: '/client/api/v1/aedDeviceRecord',

        //Flags* and Options
        flagMount: false,
        // if enable, (1) not use master rec pads status, use test reports, (2) PadLot not use, 250818
        flagPadType: true,    //this flag is used to enable/disable master record 250819

        devObj2: {},          //devObj is props, devObj2 load from axios
        savTestInfo: {},      //backup testInfo (props) before expired
        aryEmergs: [],

        statusW: '50%',
        statusH: '150',
        statusW2: '100%',
        statusH2: '400px',
        // boxBgColor: '#455A64',
        //boxBgColor: '#282828',
        boxBgColor: '#303030',
        boxTextColor: 'grey--text text--lighten-4',
        boxIconColor: 'green--text',
        mapBkColor: '#303030',
        colorNormal: 'green--text',
        colorFail: 'red--text',
        fileUpload: {},

        iconBattLevel: 0,
        iconBattColor: "green",
        iconPadsLevel: 0,
        iconPadsColor: 'green',
        iconDevStatusLevel: 0,
        iconDevStatusColor: 'green',
        iconNwkType: 0,  // 1 if 4G, 0 if wifi
        iconNwkLevel: 0,
        iconNwkColor: "green",

        // last row, set text="message", "value" displayed as a long message
        //aryBasicLast: "Last PM",
        aryBasicLast: "Customer",
        // basicInfo block is set at setStatus(), then setErrorMsg()
        // aryBasic format:  text=message(for error code), =longline1 (2 lines title), =longline2(data)
        aryBasicTbl: [
          {text: "Serial #", value: this.devObj.devSn, valueColor: 'white--text'},
          //{text: "Asset #", value: this.devObj.assetNo, valueColor: 'white--text'},
          {text: "Model", value: this.devObj.devModel, valueColor:  'white--text'},
          {text: "Installation", value: this.devObj.InstLoc, valueColor:  'white--text'},
          //{text: "Installation Date", value: this.devObj.InstTime === "/" ? "": this.devObj.InstTime, valueColor:  'white--text'},
          // aryBasic.push({text:'', value: "", valueColor:  'black--text'});  // empty line
          {text: "longline1", value: "Installation Date", valueColor:  'white--text'},
          {text: "longline2", value: this.devObj.InstTime === "/" ? "pending for installation": this.devObj.InstTime, valueColor:  'white--text'},
          //{text: "", value: "", valueColor: 'transparent'},
          {text: "Warrenty due", value: this.devObj.WarrantyExpireDate === "/" ? "unavailable": this.devObj.WarrantyExpireDate, valueColor:  'white--text'},
          {text: "Customer", value: this.devObj.CustName, valueColor:  'white--text'},
          //{text: "Battery SN", value: this.devObj.battSn, valueColor:  'white--text'},
          // PM & Preventive Maintennance -------------------
          //{text: "longline1", value: "Last preventive maintenance", valueColor:  'white--text'},
          //{text: "longline2", value: this.devObj.LastPM === "/" ? "": this.devObj.LastPM, valueColor:  'white--text'}
        ],
        aryBasic: [],
        aryDev: [{text:'Device Status', value: '', valueColor:  'white--text', msg: ''},
            {text:'Device Status', value: '', valueColor:  'red--text', msg: ''}
        ],
        aryBatt: [{text: 'Battery', value: '', valueColor:  this.boxTextColor, msg: ''}, 
            {text:'Battery', value: '', valueColor:  this.boxTextColor, msg: ''}
        ],
        aryPads: [{text:'Pads expiry Date', value: '', valueColor:  this.boxTextColor, msg: ''},
            {text:'Pads expiry Date', value: '', valueColor:  this.boxTextColor, msg: ''}
        ],
        aryNetwork: [{text:'Network Status', value: '', valueColor:  this.boxTextColor, msg: ''}, 
            {text:'Network Status', value: "", valueColor:  this.boxTextColor, msg: ''}
        ],           
        aryLoc: [{text:'Status', value: '', valueColor:  this.boxTextColor, msg: ''}
        ],            
        
        devStatusIcon: {icon: 'mdi-check-circle', color:  this.colorNormal},
        battIcon: {icon: 'mdi-battery-charging', color:  this.colorNormal},
        padsIcon: {icon: 'mdi-check-circle', color:  this.colorNormal},
        locIcon: {icon: 'mdi-map-marker-outline', color:  this.colorNormal},
        nwkIcon: {icon: 'mdi-signal', color:  'red'},
        rescueTimes: "0",

        netTitle: 'Network Status',
        selectRescue: '30',
        map: {"location": this.devObj.InstLoc},
        //outRangeLocation: "22.308699,114.176077",  //QEH
        outRangeLocation: "",  //QEH
        outRangeEnable: false,
 
        picNoImage: require("@/assets/Images/App/No_Image.png"),
        bImageExist: false,
        bImageExist2: false,
        image: '',
        // imageD1: require("@/assets/Images/Models/D1.jpg"),
        /* aryPic: [
          {src: require("@/assets/Images/Installation/pic001.jpg")},
          {src: require("@/assets/Images/Installation/pic002.jpg")},
        ] */
        vPic: 'https://cdn.vuetifyjs.com/images/cards/docks.jpg',
        aryPic: [],
      }
    },

    methods: {

      // DESCRIPTION:  handler of pic upload button
      onBtnUpload () {

      },

      onChangeUpload () {

      },

      async onChangeRescue (xitem) {
        // parameter: xitem.target.selectedIndex    type: number
        //console.log("##onChangeRescue", xitem.target.selectedIndex, typeof(xitem.target.selectedIndex));  //both types are number
        if (xitem.target.selectedIndex === undefined || xitem.target.selectedIndex === null) return;
        try {
          let flag = false;
          switch(xitem.target.selectedIndex) {
            case 0: this.selectRescue = "1"; flag=true; break;
            case 1: this.selectRescue = "7"; flag=true; break;
            case 2: this.selectRescue = "30"; flag=true; break;
            default: flag=false; break;
          }
          if (flag) {
            let vData = await this.axiosGetEmergencySn2(this.devObj.devSn);
            //console.log("##onChangeRescue", vData);
            if (vData !== undefined && vData !== null) {
              this.storeEmergToTable(vData);
            }
          }
        } 
        catch(err) { return; }
      },      

      getMapClass() {
        //console.log("#getMapClass", this.devObj.InstLoc);
        if (this.devObj2.MapLoc === "/" || this.devObj2.MapLoc === "") {
          return "d-none";
        }
        return "";
      },

      // DESCRIPTION:  for map
      // return MapLoc --> InstLoc --> DeliveryAddr --> CustName  (Address Obsoleted)
      getLocation (xitem) {
        //console.log("##getLocation", xitem);        
        if (xitem.MapLoc !== undefined && xitem.MapLoc !== null && xitem.MapLoc !== '' && xitem.MapLoc !== '/') {
          this.map.location = xitem.MapLoc;     
          return xitem.MapLoc;
        } else if (xitem.InstLoc !== undefined && xitem.InstLoc !== null && xitem.InstLoc !== '' && xitem.InstLoc !== '/') {
          this.map.location = xitem.InstLoc;     
          return xitem.InstLoc; 
        }
        else {
          this.map.location = "/"; 
          return "/";
        }
        //if (this.map.location === "" || this.map.location === "/") this.map.location = "Hong Kong";
        //return xitem.CustName;
      },

      getImage (xmodel) {
        if (xmodel === 'BeneHeart D1') return this.imageD1;
        if (xmodel === 'BeneHeart C1') return this.imageC1;
        if (xmodel === 'BeneHeart C2A') return this.imageC2A;
        if (xmodel === 'BeneHeart C2 Fully automatic') return this.imageC2auto;
        return this.imageD1;
      },

      // DESCRIPTION:  expiry date - date now, return <= 0 if expired
      getDateDiff (xdate) {
        return (new Date(xdate) - new Date())/(1000 * 3600 * 24);
      },

      setIcon (xIcon, xtype, xcolor) {
        xIcon.icon = xtype;
        xIcon.color = xcolor;
      },

      // DESCRIPTION:  dateTime in 24hour, HK format  getReceiveTime(item.receiveTime) OBSOLETED
      getReceiveTime (xDateTime) {
        //return moment(xDateTime).format("YYYY-MM-DD HH:mm:ss");  
        return xDateTime;
      },

  

      // ---------------------------------------------------------------------------------------------------
      //      [Axios]
      // ---------------------------------------------------------------------------------------------------

      // ---------------------------------------------
      // DESCRIPTION:  download picture and stored into array aryPic[]
      async axiosGetImage (xPic) {
        let config = {
            // url: 'http://192.168.253.199:7003/uploads/aedImg/C1_20240503030445.jpeg',
            url:  this.$config.apiBaseUrl + '/' + xPic,
            method: 'GET',
            responseType: 'blob',
            'headers': {
              'Authorization': 'Bearer ' + cookies.get('kk')
            }
        }

        axios(config)
          .then((response) => {
              let reader = new FileReader();
              reader.readAsDataURL(response.data); 
              reader.onload = () => {
                  //this.vPic = reader.result;
                  this.aryPic.push({src: reader.result});
              }
          }).catch( (err) => {
            //error 404 caught here:  url(inc picture) not found
            //console.log("##axiosGetImage1", err.message);
          } );
      },

    // --------------------------------------------- here**
    // DESCRIPTION:  Get deivce info Sn, V1 (with token)
    async axiosGetDevInfoV1Sn(xSn) {
      if (xSn === undefined || xSn === null || xSn === "") return null;
      let vObj = {
        'method': 'GET',
        'url': this.$config.apiBaseUrl + this.axiosPathGetDevInfoV1 + "/" + xSn,
        //'url': 'http://196.76.0.104:7021/client/api/v1/aedDeviceRecord/' + xSn,   //ok
        //'url': 'http://196.76.0.74:7021/client/api/v1/aedDeviceRecord/' + xSn,    //ok  rev1.83
        timeout: 10000,
        'headers': {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + cookies.get('kk')
        }
      }

      try {
        let resp = await axios.request(vObj.url, vObj);
        if (resp != null) {
          let vStatus = resp.data.status;
          if (vStatus === 'SUCCESS') {
            if (resp.data.data !== null) {
              return resp.data.data;
            }
          }
        } else {
          console.log('#axiosGetDevInfoV1(2b) error: receive null data');
        }
      } catch (error) {
        console.error('#axiosGetDevInfoV1(3b) error: ', error.message);
      }
      return null;
    },
      
      // ---------------------------------------------
      // DESCRIPTION:  All Emergency(Rescue) Reports
      async axiosGetEmergencySn (xSn) {
        let vObj = {
          'method': 'GET',
          'url': this.$config.apiBaseUrl + this.axiosPathEmergencySn + "/" + xSn,
          //timeout: this.connectionTimeout,
          'headers': {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + cookies.get('kk')
          }
        }
        try {
          let resp = await axios.request(vObj)
          if (resp != null) {
            let vStatus = resp.data.status;
            if (vStatus === 'SUCCESS') {
              if (resp.data.data !== undefined && resp.data.data !== null && 'data' in resp.data) {
                //this.storeEmergToTable(resp.data.data);
                return resp.data.data;
              } else {
                Ut.clearArray(this.aryEmergs);
                this.rescueTimes = "0";
              }
              return;
            } 
          } else {
            console.log('#Detail-axiosGetEmergencySn(2) error: receive null data');
          }
        } catch (error) {
          console.error('#Detail-axiosGetEmergencySn(3) error: ' + error.message);
        }
        this.rescueTimes = "0";
        return null;
      },

      // ---------------------------------------------
      // DESCRIPTION:  All Emergency(Rescue) Reports
      async axiosGetEmergencySn2 (xSn) {
        let vObj = {
          'method': 'GET',
          'url': this.$config.apiBaseUrl + "/api/v1/emergreportsWithInterval/" + xSn +"?interval=" + this.selectRescue,
          //timeout: this.connectionTimeout,
          'headers': {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + cookies.get('kk')
          }
        }
        //console.log(vObj.url);
        try {
          let resp = await axios.request(vObj)
          if (resp != null) {
            let vStatus = resp.data.status;
            if (vStatus === 'SUCCESS') {
              if (resp.data.data !== undefined && resp.data.data !== null && 'data' in resp.data) {
                //this.storeEmergToTable(resp.data.data);
                return resp.data.data;
              } else {
                Ut.clearArray(this.aryEmergs);
                this.rescueTimes = "0";
              }
              return null;
            }
          } else {
            console.log('#Detail-axiosGetEmergencySn(2) error: receive null data');
          }
        } catch (error) {
          console.error('#Detail-axiosGetEmergencySn(3) error: ' + error.message);
        }
        this.rescueTimes = "0";
        return null;
      },

      // ---------------------------------------------
      // DESCRIPTION:  load axios or sim data to this.aryEmergReport[]
      storeEmergToTable (xAry) {
        if (xAry === undefined || xAry === null) return;
        Ut.clearArray(this.aryEmergs);
        for(let idx=0; idx < xAry.length; idx++) {
          let vObj2 = xAry[idx]; 
          let vObj = Emergency.createEmergReportSn();
          vObj.devSn          = vObj2.sn;
          vObj.receiveTime    = moment(vObj2.datetime).format("YYYY-MM-DD HH:mm:ss"); 
          vObj.rescueTime     = vObj2.totalduration;
          vObj.cprDuration    = vObj2.cprduration;
          vObj.shock          = vObj2.shock;
          vObj.testTime       = "/";
          vObj.state          = "Rescue";
          vObj.hidden         = false;

          this.aryEmergs.push(vObj);
        }

        if (this.aryEmergs !== undefined && this.aryEmergs !== null) {
          this.rescueTimes = this.aryEmergs.length + " ";
          // sort receiveTime, most recent record on top
          this.aryEmergs.sort((a, b) => Ut.compareDates(a.receiveTime, b.receiveTime));
        } else {
          this.rescueTimes = "0";
        }
      },

      // ---------------------------------------------
      // DESCRIPTION:  fetch a single devInfo record
      storeDevInfo (xAry) {
        if (xAry === undefined || xAry === null || xAry.length===0) return;
        let vObj = xAry[0];     
        this.devObj2.devSn = vObj.sn;        
        this.devObj2.devModel = vObj.model;
        this.devObj2.InstLoc = vObj.instLoc;
        this.devObj2.MapLoc = vObj.maploc;
        this.devObj2.DeliveryAddr = vObj.deliveryAddress;
        this.devObj2.InstTime = moment(vObj.instTime).format("YYYY-MM-DD");     
        this.devObj2.WarrantyExpireDate = moment(vObj.warrentyDue).format("YYYY-MM-DD");
        this.devObj2.CustName = vObj.organization;
        this.devObj2.assetNo = "";
        this.devObj2.remark = "";
        //assetNo & clientRemark
        if ('clientRemark' in vObj && vObj.clientRemark != null) {
          if (vObj.clientRemark.assetNo != undefined && vObj.clientRemark.assetNo != null)
            this.devObj2.assetNo = vObj.clientRemark.assetNo;
          if (vObj.clientRemark.remark != undefined && vObj.clientRemark.remark != null)
            this.devObj2.remark = vObj.clientRemark.remark;
        }  
        this.devObj2.battSn = vObj.batterySN;
        this.devObj2.Pic = vObj.PIC;
        this.devObj2.DevSelfTestPeriod = vObj.testperiod;
        //Pads
        if ('pad' in vObj) {
          this.devObj2.PadType = Ut.getPadType(vObj.pad);
          this.aryPads[1].msg = this.devObj2.PadType;
        }
        //geofencing (true/false)
        this.devObj2.geoFencing = vObj.geofencing;
        this.outRangeLocation = this.isDistOutOfRange(vObj);
        if (this.outRangeLocation != "") this.outRangeEnable = true;
        else this.outRangeEnable = false;

        //console.log("##206", this.outRangeLocation, ", displacement=", vObj.displacement);   //debug
        this.setBasicInfo(this.aryBasic);  //load aryBasic[]
        
        //console.log("##203_xAry ", vObj); 
        //console.log("##204_devObj2 ", this.devObj2); 
      },

      // DESCRIPTION:  determine if AED distance out of range   rev1.83
      isDistOutOfRange(xObj) {
        if ('geofencing' in xObj && xObj.geofencing != undefined && xObj.geofencing == false) return "";
        if ('cellTowerLaclng' in xObj && xObj.cellTowerLaclng != undefined) {
          if ('cellTowerLocation' in xObj.cellTowerLaclng && xObj.cellTowerLaclng.cellTowerLocation != undefined) {
            this.devObj2.cellTowerLocation = xObj.cellTowerLaclng.cellTowerLocation;
            // Out of range if displacement > default value
            if (xObj.displacement > Ut.SysConf.outRangeDist) {
              let str = xObj.cellTowerLaclng.cellTowerLocation.location.lat.toFixed(7);              
              return str + ", " + xObj.cellTowerLaclng.cellTowerLocation.location.lng.toFixed(7);
            }
          }
        }
        return "";
      },
      /*  "cellTowerLaclng": {
            "cellTowerLocation": { 
              "accuracy": 124.103,
              "location": {"lat": 22.3248585, "lng": 114.2056963 }
            },
          "testinfoID": 9
          },
      */

      // ---------------------------------------------
      // DESCRIPTION:  check battery status
      checkBatteryStatus (xlevel, xStatus) {
        if (xlevel === 0) {
          this.aryBatt[0].value = "Fault";
          this.aryBatt[0].valueColor = "red--text";
          //this.setIcon(this.battIcon, "mdi-battery-alert", "red");
          this.iconBattLevel = 6;
          this.iconBattColor = "red";
          return;
        }        
        else if (xlevel <= 10.0) {
          this.aryBatt[0].value = "Low Battery";
          this.aryBatt[0].valueColor = "red--text";
          //this.setIcon(this.battIcon, "mdi-battery-alert", "red");
          this.iconBattLevel = 0;
          this.iconBattColor = "red";
          return;
        }
        else if (xlevel < 30) {
          this.aryBatt[0].value = "Low Battery";
          this.aryBatt[0].valueColor = "yellow--text";
          //this.setIcon(this.battIcon, "mdi-battery-10", "yellow");
          this.iconBattLevel = 1;
          this.iconBattColor = "yellow";          
        }
        else if (xlevel < 50) {
          this.aryBatt[0].value = "Normal";
          this.aryBatt[0].valueColor = this.boxTextColor;
          //this.setIcon(this.battIcon, "mdi-battery-20", "green");
          this.iconBattLevel = 2;
          this.iconBattColor = "green";
        }
        else if (xlevel < 70) {
          this.aryBatt[0].value = "Normal";
          this.aryBatt[0].valueColor = this.boxTextColor;
          //this.setIcon(this.battIcon, "mdi-battery-40", "green");
          this.iconBattLevel = 3;
          this.iconBattColor = "green";          
        }
        else if (xlevel < 90) {   //241025 1.55c
          this.aryBatt[0].value = "Normal";
          this.aryBatt[0].valueColor = this.boxTextColor;
          //this.setIcon(this.battIcon, "mdi-battery-60", "green");
          this.iconBattLevel = 4;
          this.iconBattColor = "green";          
        }
        else if (xlevel <= 100) {
          this.aryBatt[0].value = "Normal";
          this.aryBatt[0].valueColor = this.boxTextColor;
          //this.setIcon(this.battIcon, "mdi-battery", "green");
          this.iconBattLevel = 5;
          this.iconBattColor = "green";          
        }
        else {
          //this.setIcon(this.battIcon, "mdi-battery-charging", "green");
          this.aryBatt[0].value = "---";
          this.iconBattLevel = 0;
          this.iconBattColor = "black";          
        }

        // conform to Dashboard Limits
        //if (xlevel <= Ut.Limits.batt.value2 && xlevel > Ut.Limits.batt.value0) {
        if (xStatus === "Batt Low") {
            this.aryBatt[0].value = "Low Battery";
            this.aryBatt[0].valueColor = "yellow--text";
            this.iconBattColor = "yellow";              
        }
      },

      // ---------------------------------------------
      // DESCRIPTION:  display network status & icons, xtype=0 wifi, =1 4G, 2=NB?
      checkNetworkStatus (xlevel, xtype) {
        if (xtype === 1) {
          this.aryNetwork[1].value = "4G";
          this.iconNwkType = 1;
        }
        else if (xtype === 0) {
          this.aryNetwork[1].value = "WIFI";
          this.iconNwkType = 0;
        }
        else {
          //this.netTitle = "Network Status (N/A)";
          this.aryNetwork[1].value = "No Network";
          this.iconNwkType = 2;
        }
        this.aryNetwork[1].valueColor = "white--text";        

        let vSigStatus = Ut.getSigStatus(xtype, xlevel); 
        //if (xlevel === 0) {
        if (vSigStatus === "0") {  
          this.aryNetwork[0].value = "Receiver Fail";
          this.aryNetwork[0].valueColor = "red--text";
          this.aryNetwork[1].msg = "strength: " + vSigStatus;
          this.iconNwkLevel = 0;
          this.iconNwkColor = "red";
          if (xtype===1) this.iconNwkLevel = 4;
          return "Fault";
        } 
        //else if ((xtype===1 && xlevel <= -111) || (xtype===0 && xlevel <= -80)) {          
        else if (vSigStatus == "very weak") {   
          //this.aryNetwork[0].value = xlevel.toString() + " dBm";
          this.aryNetwork[0].value = "Warning";
          this.aryNetwork[0].valueColor = this.boxTextColor;
          // this.aryNetwork[1].msg = "Level: " + xlevel.toString() + " dBm";
          this.aryNetwork[1].msg = "strength: " + vSigStatus;
          this.iconNwkLevel = 0;
          this.iconNwkColor = "red";          
          return "Normal";
        } 
        //else if ((xtype===1 && xlevel <= -103) || (xtype===0 && xlevel <= -67)) {    
        else if (vSigStatus == "weak") {
          //this.aryNetwork[0].value = xlevel.toString() + " dBm";
          this.aryNetwork[0].value = "Warning";
          this.aryNetwork[0].valueColor = this.boxTextColor;
          //this.aryNetwork[1].msg = "Level: " + xlevel.toString() + " dBm";
          this.aryNetwork[1].msg = "strength: " + vSigStatus;
          this.iconNwkLevel = 1;
          this.iconNwkColor = "yellow";          
          return "Normal";
        } 
        //else if ((xtype===1 && xlevel <= -85) || (xtype===0 && xlevel < -30)) {    
        else if (vSigStatus == "normal") {
          //this.aryNetwork[0].value = xlevel.toString() + " dBm";
          this.aryNetwork[0].value = "Normal";
          this.aryNetwork[0].valueColor = this.boxTextColor;
          //this.aryNetwork[1].msg = "Level: " + xlevel.toString() + " dBm";
          this.aryNetwork[1].msg = "strength: " + vSigStatus;
          this.iconNwkLevel = 2;
          this.iconNwkColor = "green";          
          return "Normal";
        } 
        else {
          //if (xtype===1 || (xtype===0 && xlevel >= -30)) {  
          if (vSigStatus == "strong") {
            //this.aryNetwork[0].value = xlevel.toString() + " dBm";
            this.aryNetwork[0].value = "Normal";
            this.aryNetwork[0].valueColor = this.boxTextColor;
            //this.aryNetwork[1].msg = "Level: " + xlevel.toString() + " dBm";
            this.aryNetwork[1].msg = "strength: " + vSigStatus;
            this.iconNwkLevel = 3;
            this.iconNwkColor = "green";
            if (xtype===0 && xlevel >= -30) this.iconNwkLevel = 4;
            return "Normal";
          }
        }
        return "";
      },

      //-----------------------------------------------------
      //             [setStatus] called in mounted()
      // DESCRIPTION:  set Fault/Warning/Normal for Batt/Pads/Device
      //-----------------------------------------------------
      setStatus () {
        // devObj, testInfo
        let str = "";
        //load padsExpire, batt from sessionStorage  250722
        /*  let ary_padsSt3mon = Ut.getJson("padsSt3mon");
        let ary_aryPadExpire = Ut.getJson("padsExpire");
        let ary_batt35 = Ut.getJson("batt35");
        let ary_Fault = Ut.getJson("aryFault");   */
        let tmp = sess.get("mr");
        if (tmp == undefined || tmp == null) return;
        let vDash = JSON.parse(tmp);
        let ary_padsSt3mon = vDash.padsSt3mon;
        let ary_aryPadExpire = vDash.padsExpire;
        let ary_batt35 = vDash.batt35;
        let ary_Fault = vDash.aryFault;

        //(3) Battery:    table.js battStatusData = ['All', 'Normal', 'Fault']
        if (this.testInfo === undefined || this.testInfo === null || !("testitems" in this.testInfo)) {
          //console.log('#TblBasic-setStatus error: testInfo or testitems null');
          /* if ( this.aryBasic.length > 0) {
            let vObj = this.aryBasic[this.aryBasic.length - 1];
          } */
          this.turnOffIcons();
          return;
        }

        let j2 = 0;
        //console.log('#TblBasic-setStatus',this.testInfo );  //debug
        let netType = this.testInfo.netinfo.NetType;     // 0=wifi 1=4G, 2=NB?
        let battTot = this.testInfo.testitems.batTotalCapacity.result;
        let battRes = this.testInfo.testitems.batResidualCapacity.result;
        if (this.devObj.battSn !== "/" && this.devObj.battSn !== "" && this.devObj.battSn !== null) {
          this.aryBatt[1].msg = "Battery SN: " + this.devObj.battSn;
        } else {
          this.aryBatt[1].msg = "Battery SN: Nil";
        }
        if (battTot === 0) {
          this.aryBatt[1].value = "0";
          this.aryBatt[0].value = "Fault";
          this.aryBatt[0].valueColor = "red--text";
          //this.aryDev[0].value = 'Fault';
          this.aryDev[1].value = 'Fault';
        }
        else {
          //j2 = Math.floor((battRes * 100)/battTot);
          let battObj = Ut.getBattStatus(battRes, battTot);
          let j2 = battObj.numCapacity;
          try {
            this.aryBatt[1].value = j2.toString() + "%";
            this.aryBatt[1].valueColor = this.boxTextColor;
          } catch(err) {
            this.aryBatt[1].value = "";
          }
          this.checkBatteryStatus(j2, battObj.Status); 
        }

      //(4) Pads:     table.js PadsStatusData = ['All', 'Normal', 'Expired Soon', 'Expired']
      let expireDate = this.testInfo.testitems.padsExpiringDate.result;
      let bFlagNullExpireDate = false;
      if (expireDate != undefined && (expireDate == null || expireDate == "")) {    //250716
        bFlagNullExpireDate = true;
        //this part is to check pads info abs in testinfo, got it from master record, if present
        //(a) Pads expired in 3 months
        if (ary_padsSt3mon !== undefined && ary_padsSt3mon !== null && ary_padsSt3mon.length > 0) {
          for(let idx=0; idx < ary_padsSt3mon.length; idx++) {
            if (ary_padsSt3mon[idx].sn == this.testInfo.sn) {
              expireDate = ary_padsSt3mon[idx].padExpiry;
              break;
            }
          }
        }
        //(b) Pads expired
        if (ary_aryPadExpire !== undefined && ary_aryPadExpire!== null && ary_aryPadExpire.length > 0) {
          for(let idx=0; idx < ary_aryPadExpire.length; idx++) {
            if (ary_aryPadExpire[idx].sn == this.testInfo.sn) {
              expireDate = ary_aryPadExpire[idx].padExpiry;
              break;
            }
          }
        }
      }

      let expired = this.testInfo.testitems.padsExpiried.result;
        let dateDiff = this.getDateDiff(expireDate);
        //console.log('TblBasic-mount', expireDate, 'dateDiff=', dateDiff);        
        //(1) "Pads expiry date"
        if (this.flagPadType == false) this.aryPads[1].value = expireDate;  //as before
        else {
          if (bFlagNullExpireDate) this.aryPads[1].value = "Nil";
          else this.aryPads[1].value = expireDate;
        }
        this.aryPads[1].valueColor = this.boxTextColor;
        //(2) lot number or pads type
        if (this.flagPadType == false) {
          if ("PadLot" in this.devObj && this.devObj.PadLot !== undefined && this.devObj.PadLot !== "/" && this.devObj.PadLot !== "") 
            this.aryPads[1].msg = "lot: " + this.devObj.PadLot;
          else this.aryPads[1].msg = "lot: Nil";          
        } else {
          if ("PadType" in this.devObj && this.devObj.PadType !== undefined && this.devObj.PadType !== "/" && this.devObj.PadType !== "") {
            str = this.devObj.PadType.replaceAll(",", "/");
            if (str[str.length - 1] === '/') str = str.substring(0, str.length-1);
            this.aryPads[1].msg = "Pads type: " + str;
          }
          else this.aryPads[1].msg = "";   
        }
        if (expired > 0 || dateDiff <= 0) {
          this.aryPads[0].value = "Expired";
          this.aryPads[0].valueColor = "red--text";
          //this.setIcon(this.padsIcon, "mdi-close-circle", "red");
          this.iconPadsLevel = 0;  //0 gives a 'tick', 1 gives a 'X'
          this.iconPadsColor = "red";
          if (this.aryPads[1].value === "Nil") this.iconPadsColor = "grey";
        } else {
            if (dateDiff < 90 && dateDiff > 0) {  // 90 days --> warning
            this.aryPads[0].value = "Warning";
            this.aryPads[0].valueColor = "yellow--text";
            this.aryDev[1].value = 'Warning';
            this.aryDev[1].valueColor = 'yellow--text';
            this.iconPadsLevel = 0; 
            this.iconPadsColor = "yellow";
          } else {                             // expire > 90 days --> normal
            this.aryPads[0].value = "Normal";
            this.aryPads[0].valueColor = this.boxTextColor;
            this.iconPadsLevel = 1;
            this.iconPadsColor = "green";
          }
          if (this.aryPads[1].value === "Nil") {
            this.iconPadsColor = "grey";
            this.aryPads[0].valueColor = "black--text";
          }
        }
   
        //(5) Location:      Normal or Warning
        this.aryLoc[0].value = "Normal";
        //this.setIcon(this.locIcon, "mdi-map-marker-outline", "green");

        //(6) Network:  TestInfo.js TblTestInfo[objs]
        let nwkLvl = this.testInfo.netinfo.SignalLevel;
        this.checkNetworkStatus(nwkLvl, netType);

        //(2) Device Status     // this.testInfo.testresult? 'Normal':'Fail';   
        //                   table.js DeviceStatusData ['All', 'Normal', 'Fault', 'Warning', 'Offline']
        let errcode = this.testInfo.testerrorcode;
        errcode = errcode.replaceAll("/", "");
        errcode = errcode.trim();
        if (this.testInfo.testresult === 0 || errcode != "") {  //1st priority
          this.aryDev[1].value = "Fault";
          this.aryDev[1].valueColor = "red--text";
          /* if (errcode != "") {
            this.aryDev[1].text = "Error";
            this.aryDev[1].value = errcode;
            this.aryDev[1].valueColor = this.boxTextColor;
          } */
          //this.setIcon(this.devStatusIcon, "mdi-close-circle", "red");
          this.iconDevStatusLevel = 0;         // 0 shows icon mdiClose
          this.iconDevStatusColor = 'red';
        }
        else {
          //if (this.aryBatt[0].value === "Low Battery" || this.aryPads[0].value !== "Normal" ||  this.aryNetwork[0].value !== "Normal" ) {
          if (this.aryBatt[0].value === "Low Battery" || this.aryPads[0].value !== "Normal") {            
            //2nd priority
            this.aryDev[1].value = "Warning";
            this.aryDev[1].valueColor = "yellow--text";
            this.iconDevStatusLevel = 0;            //1 shows icon mdiCheck
            this.iconDevStatusColor = 'yellow'; 
              /* let vmsg = "Source: ";   //display status in Device Status
              if (this.aryBatt[0].value === "Low Battery") vmsg += "Battery";
              if (this.aryPads[0].value === "Warning") vmsg += " Pads";
              this.aryDev[1].msg = vmsg; */
          } else {  //3rd priority
            this.aryDev[1].value = "Normal";
            this.aryDev[1].valueColor = "white--text";
            this.setIcon(this.devStatusIcon, "mdi-check-circle", "green");
            this.iconDevStatusLevel = 1;
            this.iconDevStatusColor = 'green';            
          }
          // handle exceptional case
          if (this.aryBatt[0].value === "Fault") {          // case 1:  batt level = 0
            this.aryDev[1].value = "Fault";
            this.aryDev[1].valueColor = "red--text";          
            this.iconDevStatusLevel = 0;   // 0 shows a close-circle, 1 check-circle
            this.iconDevStatusColor = 'red';
          }
        }
        this.aryDev[1].text = "Device Status";

        //end of setStatus()
      },


      // -----------------------------------------------------------
      // DESCRIPTION:  copy aryBasicTbl[] to aryBasic[]
      initBasicAry () {
        Ut.clearArray(this.aryBasic);
        for(let idx=0; idx < this.aryBasicTbl.length; idx++) {
          this.aryBasic.push(this.aryBasicTbl[idx]);
        }
      },

      // -----------------------------------------------------------
      // DSCRIPTION:  setup aryBasic Table  250807
      //   - must execute storeDevInfo() before running this method
      //     -> assumg ethis.devObj2 content refreshed
      setBasicInfo (xtbl) {
        Ut.clearArray(xtbl);   //erase aryBasic[]
        let vObj2 = {};
        let idx = 0;
        //(1)  Serial #
        this.aryBasicTbl[0].value = this.devObj2.devSn;
        xtbl.push(this.aryBasicTbl[0]);   
        //(2)  Asset #
        if (this.devObj2.assetNo != "") {
          vObj2 = {text: "Asset #", value: this.devObj.assetNo, valueColor: 'white--text'},
          vObj2.value = this.devObj2.assetNo;
          xtbl.push(vObj2);
        }
        //(3)  Model
        idx = this.searchAryBasicText(this.aryBasicTbl, "Model"); 
        if (idx >= 0) {
          this.aryBasicTbl[idx].value = this.devObj2.devModel;
          xtbl.push(this.aryBasicTbl[idx]);
        }
        //(4)  Installation
        idx = this.searchAryBasicText(this.aryBasicTbl, "Installation"); 
        if (idx >= 0) {
          this.aryBasicTbl[idx].value = this.devObj2.InstLoc;
          xtbl.push(this.aryBasicTbl[idx]);
        }
        //(5)  Installation Date
        idx = this.searchAryBasicValue(this.aryBasicTbl, "Installation Date"); 
        if (idx >= 0 && idx+1 < this.aryBasicTbl.length) {
          this.aryBasicTbl[idx+1].value = this.devObj2.InstTime;
          xtbl.push(this.aryBasicTbl[idx]);
          xtbl.push(this.aryBasicTbl[idx+1]);
        }
        //(6)  Warrenty due
        idx = this.searchAryBasicText(this.aryBasicTbl, "Warrenty due"); 
        if (idx >= 0) {
          this.aryBasicTbl[idx].value = this.devObj2.WarrantyExpireDate;
          xtbl.push(this.aryBasicTbl[idx]);
        }        
        //(7)  Customer
        idx = this.searchAryBasicText(this.aryBasicTbl, "Customer"); 
        if (idx >= 0) {
          this.aryBasicTbl[idx].value = this.devObj2.CustName;
          xtbl.push(this.aryBasicTbl[idx]);
        }          
        //(8) Error message
        if (this.savTestInfo !== undefined && this.savTestInfo !== null && 'errorMessage' in this.savTestInfo) {
          let aryErr = this.savTestInfo.errorMessage;
          let str = "";
          if (aryErr !== undefined && aryErr !== null && aryErr != "/") {
            for(let idx=0; idx < aryErr.length; idx++) {
              if (idx === 0) str = "Fault";
              else str = "";
              if (Ut.SysConf.language === 'eng') {
                vObj2 = {text: str, value: aryErr[idx].message, valueColor:  'yellow--text'};
              }
              else {
                vObj2 = {text: str, value: aryErr[idx].chiMessage, valueColor:  'yellow--text'};
              }
              if (vObj2.text != "") xtbl.push(vObj2);
            } //end of for
          }           
        }        
        //(8)  Remark
        if (this.devObj2.remark != "") {
          xtbl.push({text: "longline1", value: "Remark", valueColor:  'white--text'});
          vObj2 = {text: "longline3", value: this.devObj2.remark, valueColor:  'white--text'};
          xtbl.push(vObj2);
        }        
      },

      // -----------------------------------------------------------
      // DESCRIPTION:  show fault message in BasicInfo block
      setErrorMsg() {
        if (this.testInfo !== undefined && this.testInfo !== null && 'errorMessage' in this.testInfo) {
          this.deleteBasicInfo();   // remove data starting from this.aryBasicLast

          let err = this.testInfo.errorMessage;
          //this.aryBasic.push({text:'', value: "", valueColor:  'black--text'});  // empty line
          let vObj = {};
          let str = "";
          if (err !== undefined && err !== null && err != "/") {
            for(let idx=0; idx < err.length; idx++) {
              if (idx === 0) str = "Fault";
              else str = "";
              if (Ut.SysConf.language === 'eng') {
                //vObj = {text:'code ' + err[idx].code, value: err[idx].message, valueColor:  'yellow--text'};
                vObj = {text: str, value: err[idx].message, valueColor:  'yellow--text'};
              }
              else {
                //vObj = {text:'code ' + err[idx].code, value: err[idx].chiMessage, valueColor:  'yellow--text'};
                vObj = {text: str, value: err[idx].chiMessage, valueColor:  'yellow--text'};
              }
              if (vObj.text != "") {
                this.aryBasic.push(vObj);
              }
            } //end of for
          } 
        }
 
        //(5) relatedtest
        /* if ('relatedtest' in this.testInfo) {
          let str2 = Ut.getRelatedTestResult(this.testInfo.relatedtest);
          if (str2 !== "Normal") {
            this.aryBasic.push(
              { text: "malfunction", value: str2, valueColor: 'yellow--text' }
            );
          }
        } */
      },

      // -----------------------------------------------------------
      // DESCRIPTION:  show remark in BasicInfo block
      setRemark() {
        if ('assetNo' in this.devObj2 && this.devObj2.assetNo != undefined && this.devObj2.assetNo != null && this.devObj2.assetNo != "") {
          //search if assetNo already in aryBasic
          //if (this.aryBasic.indexOf("Asset #") < 0) {
          let idx = this.searchAryBasicText(this.aryBasic, "Asset #");
          if (idx < 0) {
            let vObj = {text: "Asset #", value: this.devObj2.assetNo, valueColor:  'white--text'};
            this.aryBasic.splice(1, 0, vObj);
          }
        }

        if ('remark' in this.devObj2 && this.devObj2.remark != undefined && this.devObj2.remark != null && this.devObj2.remark != "") {
          //search if assetNo already in aryBasic
          //if (this.aryBasic.indexOf("Remark") < 0) {
          let idx = this.searchAryBasicValue(this.aryBasic, "Remark");
          if (idx < 0) {
            let vObj = {text: "longline1", value: "Remark", valueColor:  'white--text'};
            this.aryBasic.push(vObj);
            vObj = {text: "longline3", value: this.devObj2.remark, valueColor:  'white--text'};
            this.aryBasic.push(vObj);
          }
        }
      },

      // -----------------------------------------------------------
      // DESCRIPTION:  set to MR60/61 (no data), OR MR62/MR63
      setPadsType (xTurnOn) {
        if (xTurnOn) {
          if (this.aryPads[1].value === "Nil")
            this.aryPads[1].msg = "Pads type: MR60/MR61";
          else this.aryPads[1].msg = "Pads type: MR62/MR63";
        }
        else this.aryPads[1].msg = "Pads type: MR60/MR61";
      },

      // -----------------------------------------------------------
      // DESCRIPTION:  all icons to grey color
      turnOffIcons () {
        //console.log("##TblBasic-turnOffIcons");
        this.iconBattLevel = 0;
        this.iconBattColor = 'grey';
        this.iconPadsLevel = 0;
        this.iconPadsColor = 'grey';
        this.iconDevStatusLevel = 0;
        this.iconDevStatusColor = 'grey';
        this.iconNwkLevel = 0;
        this.iconNwkColor = 'grey';

        // if testreport absent, use Nil, rather than N/A
        this.aryBatt[0].value = "Nil"; this.aryBatt[0].valueColor = "grey--text";
        this.aryBatt[1].value = "Nil"; this.aryBatt[1].valueColor = "grey--text";
        this.aryPads[0].value = "Nil"; this.aryPads[0].valueColor = "grey--text";
        this.aryPads[1].value = "Nil"; this.aryPads[1].valueColor = "grey--text";
        this.aryDev[0].value = "Nil"; this.aryDev[0].valueColor = "grey--text";
        this.aryDev[1].value = "Nil"; this.aryDev[1].valueColor = "grey--text";
        this.aryNetwork[0].value = "Nil"; this.aryNetwork[0].valueColor = "grey--text";
        this.aryNetwork[1].value = "Nil"; this.aryNetwork[1].valueColor = "grey--text";                        

        if (!this.searchAryBasicValue(this.aryBasic, "Test Report unavailable")) {
          //this.aryBasic.push({text:'', value: "", valueColor:  'black--text'});  // empty line
          this.aryBasic.push({text:'', value: "Test Report unavailable", valueColor:  'yellow--text'});  // empty line
        }

        this.aryPads[1].msg = "";
      },

      // ----------------------------------------------------------- Ut
      searchAryBasicValue(xtbl, xValue) {
        if (xtbl === undefined || xtbl === null) return -1;
        for(let idx=0; idx < xtbl.length; idx++) {
          if (xtbl[idx].value === xValue) return idx;
        }
        return -2;
      },

      searchAryBasicText(xtbl, xText) {
        if (xtbl === undefined || xtbl === null) return -1;
        for(let idx=0; idx < xtbl.length; idx++) {
          if (xtbl[idx].text === xText) return idx;
        }
        return -2;
      },      

      deleteBasicInfo() {
        if (this.aryBasic === undefined || this.aryBasic === null) return;
        for(let idx=0; idx < this.aryBasic.length; idx++) {
          if (this.aryBasic[idx].text === this.aryBasicLast) {
            this.aryBasic = this.aryBasic.splice(0, idx + 1);
            return;
          }
        }
      },

      async reloadPage () {
        this.selectRescue = "30";
        this.initBasicAry();

        let vDevInfo = await this.axiosGetDevInfoV1Sn(this.devObj.devSn);
        if (vDevInfo !== undefined && vDevInfo !== null) {
          this.storeDevInfo(vDevInfo);
        }

        // Load rescue info to Timeline
        //let vRescue = await this.axiosGetEmergencySn(this.devObj.devSn);
        let vRescue = await this.axiosGetEmergencySn2(this.devObj.devSn);  //with interval=days
        if (vRescue !== undefined && vRescue !== null) {
          this.storeEmergToTable(vRescue);
        }

        // Load picture to Carousel
        if (this.devObj2.Pic !== undefined && this.devObj2.Pic !== null) {
          for(let idx=0; idx < this.devObj2.Pic.length; idx++) {
            this.axiosGetImage(this.devObj2.Pic[idx]);
          }
          if (this.devObj2.Pic.length === 0) {
            this.bImageExist = false;
          } else {
            this.bImageExist = true;
          }
        } else {
          this.bImageExist = false;
        }

        // turn off icons, if test report not availabe
        if (!this.devObj.testreport) {
          this.turnOffIcons();  
        } else {
          this.setPadsType(true);
        }
      },

    },  //end of method


    //==============================================================================
    //             mount & watch
    //==============================================================================
       
    async mounted () {
      // props:  devObj, testInfo
      //console.log("##basicInfo-mount");  //debug
      this.flagMount = true;          //<reload> webpage
      this.reloadPage();
    },

    watch: {
      // props:  devObj(from DashBoard.vue), testInfo(from DevInfoDetail.vue)      
      trigger: function(newVal) {
        if ( this.testInfo !== undefined && this.testInfo !== null && this.devObj.testreport)
          this.savTestInfo = Ut.copyObject(this.testInfo);    //backup testInfo
        //console.log("##basicInfo-watch", this.testInfo);  //debug

        if (this.flagMount === false) {      //<refresh btn>
          this.reloadPage();
          if ( this.testInfo === undefined || this.testInfo === null || !this.devObj.testreport)
            this.turnOffIcons();  
          else {
            this.setStatus();
            this.setPadsType(true);
          }
          this.flagMount = false;
          return;
        }

        if ( this.testInfo === undefined || this.testInfo === null || !this.devObj.testreport)  {
          // turn off icons if test report not available
          this.turnOffIcons();        
        } else {
          // set icon levels and display
          this.setStatus();
          this.setErrorMsg();
          this.setPadsType(true);
          //this.aryBasic[2].value = this.getLocation(this.devObj);
        }   

        // aryBasic[] :  handle assetNo(1), remark
        this.setRemark();

        // aryBasic[] :  handle installation location(idx=2 or 3)
        /* let str =  this.devObj.InstLoc;
        if (str === undefined || str === null || str === '' || str === '/') str = "/";        
        if (this.searchAryBasicText(this.aryBasic, "Asset #")==false) 
          this.aryBasic[2].value = str;
        else this.aryBasic[3].value = str;  */

        if (!this.devObj.testreport) {  //testreport abs for this sn
          this.turnOffIcons();  
        }

        this.flagMount = false;
        //console.log("##BasicInfo1", this.devObj);  //debug*
        //console.log("##BasicInfo2", this.testInfo);  //debug*
      }      
    } //end of watch

  }
</script>

<style scoped>

#id_timeline { 
  overflow: hidden; 
  -ms-overflow-style: none; 
  scrollbar-width: none; 
}

#id_timeline::-webkit-scrollbar {
    display: none;
}

.theme--dark.v-timeline:before {
    background: orange;
}

.fontN {
  font-family: Montserrat; 
  font-style: normal; 
  font-weight: normal;   
  color: white;
}

.fontB {
  font-family: Montserrat; 
  font-style: normal; 
  font-weight: bold;   
  color: white;
}

.fontN2 {
  font-family: Montserrat; 
  font-style: normal; 
  font-size: 0.8em;
  font-weight: normal;   
  color: white;
}

.fontN3 {
  font-family: Montserrat; 
  font-style: normal; 
  font-size: 1.0em;
  font-weight: normal;   
  color: white;
}

/* for number only */
.fontN3W {
  font-family: Terminal; 
  font-style: normal; 
  font-size: 0.7em;
  font-weight: normal;   
  color: white;
}

.fontN3B {
  font-family: Montserrat; 
  font-style: normal; 
  font-size: 0.8em;
  font-weight: normal;   
  color: black;
}

.fontTimeLine1 {
  font-family: Montserrat; 
  font-style: normal; 
  font-size: 1.4em;
  font-weight: normal;   
  color: white;
}

.fontTimeLine2 {
  font-family: Montserrat; 
  font-style: normal; 
  font-size: 1.0em;
  font-weight: normal;   
  color: white;
}

.fontTimeLst {
  font-family: Montserrat !important; 
  font-style: normal; 
  font-size: .9em;
  font-weight: normal;   
  color: white;
}

.bg_page {
  background-color: #424141;
}

.bg_card {
  background-color: #303030;
}


</style>
